/**
 * ChittravanLogoMark — just the camera+tree SVG icon, no text.
 * Ported from V1 (web/components/ui/Logo.tsx). V1 fills the brand-color shapes
 * with `rgb(var(--color-cosmic-accent))`.
 *
 * In V2 the brand color is the `primary` token. NOTE: V2's globals.css stores
 * `--primary` as a COMPLETE color value (e.g. `hsl(243.4, 75.4%, 58.6%)`), not a
 * bare HSL triplet — so the SVG fill references it directly as `var(--primary)`.
 * (Wrapping it in `hsl(...)` would double-nest the function and produce an
 * invalid color, since the token already includes the `hsl()` wrapper.)
 */

/** Standalone icon — use next to existing text */
export function ChittravanLogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      aria-hidden="true"
      className="shrink-0"
    >
      <rect width="32" height="32" rx="6" fill="var(--primary)" />
      {/* Geometric tree */}
      <polygon points="16,2 10,10 22,10" fill="white" />
      <polygon points="16,7 8,16 24,16" fill="white" />
      {/* Camera viewfinder bump */}
      <rect x="12" y="15" width="8" height="4" rx="1" fill="white" />
      {/* Camera body */}
      <rect x="4" y="18" width="24" height="11" rx="2" fill="white" />
      {/* Lens ring */}
      <circle cx="16" cy="23" r="4.5" fill="var(--primary)" />
      {/* Lens inner */}
      <circle cx="16" cy="23" r="3" fill="white" fillOpacity="0.5" />
      {/* Lens centre */}
      <circle cx="16" cy="23" r="1.4" fill="white" />
      {/* Lens highlight */}
      <circle cx="14.5" cy="21.5" r="0.7" fill="white" opacity="0.8" />
    </svg>
  );
}
